
const content = {
    'instagram_user_following': {
        en: {
            data_type_description: 'Instagram User Following',
            summary_no_video_html: `
            <p>We've got a great new Retro task for you - Instagram Following. Its really simple and quick - just follow these simple instructions.</p>
        `,
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: '<p>Open the <b>Instagram</b> app on your phone.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: '<p>Tap on your profile icon (bottom right hand corner of your screen - it usually has your picture).</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: `<p>Tap on <b>Following</b> - top right of screen</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: `<p>Now turn on your screen recorder.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '5',
                    description_html: '<p>Scroll to the bottom of your screen of people you are following - until you get the bottom of the page.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '6',
                    description_html: '<p>Turn off your screen recording.</p>'
                }
            ],
        },
    },
    'instagram_shopping_history': {
        en: {
            data_type_description: 'Instagram Shopping History',
            summary_html: '',
            summary_no_video_html: `
                <p>Retro jobs are simple and quick. Read the steps below, and then scroll
                    through your Instagram shopping history.</p>
                <p>Before you start — <b>it's important to make sure that you follow the Instagram instructions that are
                    relevant to you!</b> Instagram currently has two versions of its app available for its users.</p>
                <p>Check which version of the app you have below, then follow the correct steps as we can only pay you MSR
                    rewards for videos that fully match the steps. It is fine if you don't yet have anything in your order
                    history, just as long as you followed the steps.</p>
                <hr/>
                <p class="tag-row"><span class="info-tag">Version 1</span></p>
                <p>If your app has the "like" icon at the bottom of the home screen of the app (as shown here) then
                    <a href="#version-1">follow the first set of steps</a>.</p>
                <p class="centered-intro-image">
                    <img src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/instagram-shopping-history/instagram-like-icon.png" alt="" />
                </p>
                <p class="tag-row"><span class="info-tag">Version 2</span></p>
                <p>Alternatively, if your app has the "shopping bag" icon at the bottom of the home screen, then
                    <a href="#version-2">follow the second set of steps</a>.</p>
                <p class="centered-intro-image">
                    <img src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/instagram-shopping-history/instagram-shopping-bag-icon.png" alt="" />
                </p>
                <hr class="hr-with-space-below" />`,
            steps: [
                {
                    step_type: 'content_step',
                    content_html: `<span class="info-tag" id="version-1">Version 1</span>`
                },
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: `<p>Open the <b>Instagram</b> app and make sure you're logged in.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: '<p>Go to your Instagram profile and tap on the menu icon.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: '<p>Tap on <b>Orders and payments</b> and start recording.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: `<p>Tap on each order in turn and scroll through the entire order. Repeat until no more
                    orders. <i>Don’t worry if you don’t have any orders — please still send in the recording up until this step</i>.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '5',
                    description_html: '<p>Stop recording and upload the video.</p>'
                },
                {
                    step_type: 'emoji_step',
                    emoji: '🤔',
                    description_html: `<p>Hmmm. Didn't find Orders and payments in the menu? Try these other steps...</p>`
                },
                {
                    step_type: 'content_step',
                    content_html: `<span class="info-tag" id="version-2">Version 2</span>`
                },
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: '<p>Tap on the shopping bag icon in the main nav..</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: '<p>Tap on the menu icon in the top-right and then select <b>Orders</b>.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: `<p>Tap on each order in turn and scroll through the entire order. Repeat until no more
                    orders. <i>Don’t worry if you don’t have any orders — please still send in the recording up until this
                    step</i>.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: '<p>Stop recording and upload the video.</p>'
                },
                {
                    step_type: 'emoji_step',
                    emoji: '🤔',
                    description_html: `<p>Hmmm. Still didn't find <b>Orders</b> in the menu? Please still submit a video up until
                    step #2 in the second part of the instructions above.</p>`
                }
            ],
        },
    },
    'instagram_ad_history': {
        en: {
            data_type_description: 'Instagram Ad Activity',
            summary_html: `
            <div style="margin-top:1.0rem;"><b>Before your start</b></div>
            <p>It's important you complete each step, or we won’t be able to process your payment! Please read all 9 steps before starting.</p>`,
            summary_no_video_html: `
            <div style="margin-top:1.0rem;"><b>Before your start</b></div>
            <p>It's important you complete each step, or we won’t be able to process your payment! Please read all 9 steps before starting.</p>`,
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: '<p>Open the Instagram app <img style="height:20px;margin-right:2px;margin-left:2px;" src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/instagram-ad-activity/icon@3x.png" /> on your smartphone</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: `
                <p>
                    Start <img style="height:20px;margin-right:2px;margin-left:2px;" src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/record@3x.png" /> screen recording. (If you don’t know how to screen record, click on link above)
                </p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: `<p>Click on your <b>Profile</b> in the bottom right navigation</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: `<p>Open the menu <img style="height:20px;margin-right:2px;margin-left:2px;" src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/instagram-ad-activity/menu@3x.png" /> in the top right corner</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '5',
                    description_html: '<p>Tap <img style="height:20px;margin-right:2px;margin-left:2px;" src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/instagram-ad-activity/settings@3x.png" /> <b>Settings</b> > <img style="height:20px;margin-right:2px;margin-left:2px;" src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/instagram-ad-activity/activity@3x.png" /> <b>Ads</b> > <b>Ad activity</b></p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '6',
                    description_html: '<p><b>Scroll to the bottom of the page</b> through the posts</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '7',
                    description_html: '<p>Stop the screen recording</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '8',
                    description_html: '<p>Upload the video file</p>'
                },
            ],
        },
    },
    'instagram_link_history': {
        en: {
            data_type_description: 'Instagram Link Activity',
            summary_html: `
                <p>Retro jobs are simple and quick. Watch the video and read the steps below, and then you're ready
                    to hit record and scroll through your Instagram Link Activity.</p>
                <p>Even if you don't have anything in your Link Activity, please follow these steps</p>
                <div class="text-with-icon">
                    <div class="icon">⚠️</div>
                    <div class="text">
                        We’ll only pay MSR rewards for videos that fully match the steps below.
                    </div>
                </div>`,
            summary_no_video_html: `
                <p>Retro jobs are simple and quick. Read the steps below, and then you're ready to hit record and scroll
                    through your Instagram Link Activity.</p>
                <p>Even if you don't have anything in your Link Activity, please follow these steps.</p>
                <div class="text-with-icon">
                    <div class="icon">⚠️</div>
                    <div class="text">
                        We’ll only pay MSR rewards for videos that fully match the steps below.
                    </div>
                </div>`,
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: '<p>Open the <b>Instagram</b> app on your phone.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: '<p>Go to your Instagram profile and tap on the menu icon.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: `<p>Tap on <b>Your activity</b> and make sure <b>Links</b> is selected.
                    Start recording.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: `<p>Scroll through the entire Link Activity list. <i>Don’t worry if
                    it's empty — please still send in the recording up until this step</i></p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '5',
                    description_html: '<p>Stop recording and upload the video.</p>'
                }
            ],
        },
    },
    'whatsapp_data_upload': {
        en: {
            data_type_description: 'WhatsApp - MetaAI -  Data Upload',
            summary_no_video_html: '<p>Please upload your WhatsApp MetaAI data file by following the instructions below:</p>',
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: '<p>Open <b>WhatsApp</b> and tap into the <b>Meta AI</b> chat (look for the colourful ring)..</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: '<p>Tap on  <b>“Meta AI with Llama 4”</b> at the top.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: '<p>On iOS, scroll to the bottom and tap <b>Export chat</b>, and select “Without media”.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: '<p>On Android, tap the <b>three dots</b> in the top-right corner and tap <b>Export chat</b>.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '5',
                    description_html: '<p>Download the file (for iOS, download to the Files app; for Android, download to Google Drive or local file).</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '6',
                    description_html: `<p>Finally, tap <b>Choose file</b> below and upload the file.</p>`
                }
            ]
        }
    },
    'meta_muse_data_upload': {
        en: {
            data_type_description: 'Meta Muse AI - Data Upload',
            summary_no_video_html: '<p>Please upload your Meta Muse data file by following the instructions below:</p>',
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: '<p>Open the <b>Meta Muse</b> app.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: '<p>Tap on <b>double-bar icon</b> at top left.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: '<p>Tap on <b>gear icon</b> at top.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: '<p>Click <b>Data controls</b>.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '5',
                    description_html: '<p>Tap <b>Download your agent data</b>.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '6',
                    description_html: '<p>Download the file (for iOS, download to the Files app; for Android, download to Google Drive or local file).</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '7',
                    description_html: `<p>Finally, tap <b>Choose file</b> below and upload the file.</p>`
                }
            ]
        }
    }
}

export const metaDataTypes = {
    'instagram_user_following': {
        data_type: 'instagram_user_following',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/instagram-ad-activity/logo.jpg',
        capture_type: 'video',
        generic: {
            use_in_app_screen_recorder: false,
            ...content.instagram_user_following
        },
        ios: {
            use_in_app_screen_recorder: false,
            ...content.instagram_user_following
        },
        android: {
            use_in_app_screen_recorder: true,
            ...content.instagram_user_following
        }
    },
    'instagram_shopping_history': {
        data_type: 'custom_video',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/instagram-shopping-history/logo.jpg',
        capture_type: 'video',
        android: {
            use_in_app_screen_recorder: true,
            ...content.instagram_shopping_history
        },
        ios: {
            use_in_app_screen_recorder: false,
            ...content.instagram_shopping_history
        }
    },
    'instagram_ad_activity': {
        data_type: 'custom_video',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/instagram-ad-activity/logo.jpg',
        capture_type: 'video',
        android: {
            use_in_app_screen_recorder: true,
            ...content.instagram_ad_history,
        },
        ios: {
            use_in_app_screen_recorder: false,
            ...content.instagram_ad_history,
        },
    },
    'instagram_link_activity': {
        data_type: 'custom_video',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/instagram-ad-activity/logo.jpg',
        capture_type: 'video',
        android: {
            use_in_app_screen_recorder: true,
            ...content.instagram_link_history,
        },
        ios: {
            use_in_app_screen_recorder: false,
            ...content.instagram_link_history,
        },
    },
    whatsapp_data_upload: {
        data_type: 'whatsapp_data_upload',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/whatsapp/logo.png',
        capture_type: 'file',
        use_in_app_screen_recorder: false,
        require_consent: true,
        generic: {
            ...content.whatsapp_data_upload,
        }
    },
    meta_muse_data_upload: {
        data_type: 'meta_muse_data_upload',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/meta-muse/logo.png',
        capture_type: 'file',
        use_in_app_screen_recorder: false,
        require_consent: true,
        generic: {
            ...content.meta_muse_data_upload,
        }
    }
}
